export default {
  // Tooltip 內容
  selectAll: "全選 (ctrl+a/command+a)",
  invertSelect: "反選",
  verticalArrange: "縱向排列（只支持單列）",
  backToCenter: "回到中心",
  deleteNode: "刪除節點 (delete)",
  previousStep: "上一步 (ctrl+z/command+z)",
  nextStep: "下一步 (ctrl+f/command+f)",
  saveCanvas: "保存畫布 (alt+s/⌥+s)",
  fullScreen: "全屏 ",
  exitFullScreen: "取消全屏",

  // emit 事件文本
  saveCanvasAction: "保存畫布",
  fullScreenCanvas: "全屏畫布",
  exitFullScreenAction: "取消全屏",
  relevance: "關聯",
};
